import React from 'react';

import {
  SliderRoot,
  SliderTrack,
  SliderThumb,
} from '@repo/ui/components/ui/slider';

export const RangeSlider = React.forwardRef<
  React.ElementRef<typeof SliderRoot>,
  React.ComponentPropsWithoutRef<typeof SliderRoot> & {
    leftThumbPopoverText: string;
    rightThumbPopoverText: string;
    showThumbPopovers?: boolean;
  }
>(
  (
    {
      leftThumbPopoverText,
      rightThumbPopoverText,
      showThumbPopovers = true,
      ...props
    },
    ref,
  ) => {
    return (
      <SliderRoot ref={ref} {...props}>
        <SliderTrack className="h-2" rangeClassName="bg-cn-primary" />

        <SliderThumb
          className="h-5 w-5 border-2 border-cn-primary"
          tag={showThumbPopovers && leftThumbPopoverText}
        />

        <SliderThumb
          className="h-5 w-5 border-2 border-cn-primary"
          tag={showThumbPopovers && rightThumbPopoverText}
        />
      </SliderRoot>
    );
  },
);
